"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitPlaylistAdId = void 0;
/**
 * An ad ID in a playlist is a composite ID of ad server ID and creative ID, separated by `::`.
 * This helper splits the ad ID into its components.
 */
const splitPlaylistAdId = (playlistAdId) => {
    const separatorIndex = playlistAdId.indexOf('::');
    if (separatorIndex === -1) {
        return undefined;
    }
    const adServerId = playlistAdId.substring(0, separatorIndex);
    const creativeId = playlistAdId.substring(separatorIndex + 2);
    const isBuiltIn = adServerId === 'edge-built-in';
    return {
        adServerId,
        isBuiltIn,
        creativeId,
    };
};
exports.splitPlaylistAdId = splitPlaylistAdId;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRJbnNlcnRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvYWRJbnNlcnRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7OztHQUdHO0FBQ0ksTUFBTSxpQkFBaUIsR0FBRyxDQUM3QixZQUFvQixFQUNzRCxFQUFFO0lBQzVFLE1BQU0sY0FBYyxHQUFHLFlBQVksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDakQsSUFBSSxjQUFjLEtBQUssQ0FBQyxDQUFDLEVBQUUsQ0FBQztRQUN4QixPQUFPLFNBQVMsQ0FBQTtJQUNwQixDQUFDO0lBRUQsTUFBTSxVQUFVLEdBQUcsWUFBWSxDQUFDLFNBQVMsQ0FBQyxDQUFDLEVBQUUsY0FBYyxDQUFDLENBQUE7SUFDNUQsTUFBTSxVQUFVLEdBQUcsWUFBWSxDQUFDLFNBQVMsQ0FBQyxjQUFjLEdBQUcsQ0FBQyxDQUFDLENBQUE7SUFDN0QsTUFBTSxTQUFTLEdBQUcsVUFBVSxLQUFLLGVBQWUsQ0FBQTtJQUVoRCxPQUFPO1FBQ0gsVUFBVTtRQUNWLFNBQVM7UUFDVCxVQUFVO0tBQ2IsQ0FBQTtBQUNMLENBQUMsQ0FBQTtBQWpCWSxRQUFBLGlCQUFpQixxQkFpQjdCIn0=